import { AxiosError } from 'axios'
import React from 'react'
import useSnackbarStore from './useSnackbarStore'

const getCustomMessage = (message: string) => {
  const map: Record<string, string> = {
    INVALID_EMAIL: 'Work email required. If you would like an exception to our policy, please contact us.',
  }

  return map[message] || message
}

const useShowError = () => {
  const { openSnackbar } = useSnackbarStore()

  return React.useCallback(
    (error: unknown, setMessage?: (value: React.SetStateAction<string>) => void) => {
      let message = ''

      if (error instanceof AxiosError) message = error.response?.data?.message || error.message
      else if (error instanceof Error) message = error.message
      else message = 'An unexpected error has occurred. Please try again or contact us.'

      message = getCustomMessage(message)

      if (setMessage) setMessage(message)
      else openSnackbar(message, 'error')
    },
    [openSnackbar]
  )
}

export default useShowError
